"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  view_article_text: 'View Article',
  modal_close_text: 'Close',
  input_placeholder: 'Type a message',
  unsupported_message: '[Unsupported message]',
  page_head_title: 'Shebi',
  btn_choose_issue: 'Choose Issue',
  delivered_by_text: 'Delivered by',
  copy_text: 'COPY',
  more_order_text: 'Other Orders',
  total_payment_text: 'Total Payment',
  item_text: 'Item',
  items_text: 'Items',
  order_id: 'Order Id',
  seller_order_list_title_text: 'Select orders',
  buyer_order_list_title_text: 'My Purchase',
  label_withdrawal: 'Withdrawal',
  label_topup: 'Topup'
};
exports.default = _default;